/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Delete_Document_Confirm_TitleInputs */

const en_orders_delete_document_confirm_title = /** @type {(inputs: Orders_Delete_Document_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this document?`)
};

const es_orders_delete_document_confirm_title = /** @type {(inputs: Orders_Delete_Document_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Eliminar este documento?`)
};

/**
* | output |
* | --- |
* | "Delete this document?" |
*
* @param {Orders_Delete_Document_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_delete_document_confirm_title = /** @type {((inputs?: Orders_Delete_Document_Confirm_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Delete_Document_Confirm_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_delete_document_confirm_title(inputs)
	return es_orders_delete_document_confirm_title(inputs)
});